let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6kTP9")).then(() => parcelRequire('VKZ52'));